"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indicatorFinalClaimSchema = void 0;
var constants_1 = require("../../constants");
exports.indicatorFinalClaimSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'claimProcessingUnitTypeCode',
        'claimReceivedDate',
        'eddFemsiFlag',
        'editsAndAllowancesFlag',
        'enhancedAcppFlag',
        'notepadCommentFlag',
        'paymentCount',
        'rffiFlag',
        'underwritingReviewFlag',
    ],
    properties: {
        claimProcessingUnitTypeCode: {
            type: 'string',
            minLength: 1,
            maxLength: 2,
            enum: Object.values(constants_1.ClaimProcessUnitType),
            errorMessage: 'Should equate to a valid ClaimProcessUnitType enum value',
        },
        claimReceivedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format',
        },
        eddFemsiCodes: {
            type: ['array', 'null'],
            items: {
                type: ['string', 'null'],
                minLength: 2,
                maxLength: 2,
            },
            errorMessage: 'should be an array of strings with 2 characters or null',
        },
        eddFemsiFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        editsAndAllowancesFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        enhancedAcppFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        gvsPviiFlag: {
            type: ['boolean', 'string', 'null'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean or null',
        },
        notepadCommentFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        paymentCount: {
            type: 'integer',
            minimum: -2147483648,
            maximum: 2147483648,
            errorMessage: 'Should be an integer between -2147483648 and 2147483648',
        },
        rffiFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        underwritingInformationReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        underwritingInformationRequestedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        underwritingReviewEndDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        underwritingReviewFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        underwritingReviewStartDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
    },
};
